import type { IconAsset } from '../Icon.types';

const code = (
  <g id='international' transform='translate(-496 194)'>
    <rect
      fill='#fff'
      height='24'
      opacity='0'
      transform='translate(496 -194)'
      width='24'
    />
    <g transform='translate(-192.962 -940.622)'>
      <path
        d='M7.5,1A6.5,6.5,0,1,0,14,7.5,6.507,6.507,0,0,0,7.5,1m0-1A7.5,7.5,0,1,1,0,7.5,7.5,7.5,0,0,1,7.5,0Z'
        fill='currentColor'
        transform='translate(692.962 751.622)'
      />
      <path
        d='M699.156,766.621a11.31,11.31,0,0,1,.021-15.022l.763.647a10.311,10.311,0,0,0-.019,13.73Z'
        fill='currentColor'
      />
      <path
        d='M701.761,766.671l-.761-.649a10.317,10.317,0,0,0-.031-13.838l.759-.651a11.316,11.316,0,0,1,.033,15.138Z'
        fill='currentColor'
      />
      <path
        d='M.5,14.866h-1V0h1Z'
        fill='currentColor'
        transform='translate(700.48 751.693)'
      />
      <path
        d='M14.866.5H0v-1H14.866Z'
        fill='currentColor'
        transform='translate(693.017 759.126)'
      />
      <path
        d='M700.463,755.93a13.867,13.867,0,0,1-5.789-1.244l.415-.91a13.1,13.1,0,0,0,10.733.008l.413.911A13.867,13.867,0,0,1,700.463,755.93Z'
        fill='currentColor'
      />
      <path
        d='M695.088,764.464l-.415-.91a14.09,14.09,0,0,1,11.561-.007l-.414.91a13.09,13.09,0,0,0-10.733.007Z'
        fill='currentColor'
      />
    </g>
  </g>
);

export const globe: IconAsset = {
  regular: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
};
